import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useFilterIcon from 'hooks/useFilterIcon';
import useAppUser from 'hooks/useAppUser';
import {
  Container,
  InboxRowStyled,
  PageHeaderFilterWrapper,
  PageHeaderStyled,
} from './Inbox.styles';
import InboxFilter from './filter/InboxFilter';
import InboxFilterLoader from './filter/InboxFilterLoader';
import InboxThreads from './threads/InboxThreads';
import InboxMessages from './messages/InboxMessages';
import useInboxInit from './useInboxInit';
import InboxThreadRightPanel from './lead/InboxThreadRightPanel';
import InboxLeadStandalone from './lead/InboxLeadStandalone';
import { inboxFilterFormExpandedStorageKey } from './filter/InboxFilter.constants';
import InboxFilterFormProvider from './filter/InboxFilterFormProvider';
import InboxLeadFilter from './lead/InboxLeadFilter';
import { cleanUpMessageContentClassNamesCache } from './messages/InboxMessage.utils';

const InboxBody = memo(() => {
  const { t } = useTranslation();
  const { isLoading } = useInboxInit();
  const { isOwner } = useAppUser();
  const { filterIconWithCounterFromForm: FilterIconRenderer, isFilterOpen } =
    useFilterIcon({
      stateStorageKey: inboxFilterFormExpandedStorageKey,
    });

  useEffect(() => {
    return () => {
      cleanUpMessageContentClassNamesCache();
    };
  }, []);

  return (
    <Container>
      <InboxFilterFormProvider>
        <PageHeaderStyled title={t('pageInbox.inboxHeader')}>
          {!isOwner && (
            <PageHeaderFilterWrapper>
              <InboxLeadFilter />
              <FilterIconRenderer />
            </PageHeaderFilterWrapper>
          )}
        </PageHeaderStyled>

        {!isLoading && !isOwner && <InboxFilter isFilterOpen={isFilterOpen} />}
      </InboxFilterFormProvider>

      {isLoading && !isOwner && <InboxFilterLoader />}
      {!isLoading && (
        <>
          <InboxLeadStandalone />
          <InboxRowStyled>
            <InboxThreads />
            <InboxMessages />
            <InboxThreadRightPanel />
          </InboxRowStyled>
        </>
      )}
    </Container>
  );
});

export default InboxBody;
